"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const assert = require('assert').strict;
const { resolveExpression } = require('../evaluate');
const { STARTS_WITH } = require('../definitions/operators');
const { evaluateMatcher } = require('./utils');
exports.accepts = ({ operator }) => operator === STARTS_WITH;
exports.resolve = ({ right, left }, context) => __awaiter(void 0, void 0, void 0, function* () {
    assert(context);
    assert(right);
    assert(left);
    const leftResolved = yield resolveExpression(left, context);
    const rightResolved = yield resolveExpression(right, context);
    const matcher = (comparisonString) => (item) => comparisonString.startsWith(item);
    return evaluateMatcher(leftResolved, rightResolved, matcher);
});
//# sourceMappingURL=startsWithExpression.js.map